import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const ThumbnailButtonContainer = styled.div`
  margin: ${themeGet('spacing.turquoise20_1_25rem')}
    ${themeGet('spacing.turquoise20_1_25rem')} 0 0;
`
